import {Status}  from '../_commons/const';
import {Map, List} from 'immutable';

/** Gère une collection REST
 *
 * @param defaultStateAugment Array champs à ajouter à l'état initial si il en a
 * @param actions Object Mapping des actions Redux aux actions REST
 * @param fallback Function Appelée si aucune des actions mappées ne correspond
 * @returns {Function}
 */
export default function ({defaultStateAugment, actions, fallback}) {
  return function (state = initialState, action) {
    if (Object.keys(defaultStateAugment).length > 0) {
      const err = 'TODO Can\'t provide more keys until something like ImmutableJS is used';
      throw new Error(err);
    }
    const answer = stateGenerator(state, action.parent);

    let isACaseOf = (...types) => {
      let typesL = flatten(types);

      return typesL.indexOf(action.type) !== -1;
    };

    if (isACaseOf(actions.index.start)) {
      return answer(Status.LOADING)
    } else if (isACaseOf(actions.index.success)) {
      return answer(Status.OK, action.items.reduce((prv, cur) => prv.set(cur.id, cur), state.items));
    } else if (isACaseOf(actions.index.failure)) {
      return answer(Status.FAILURE, Map());
    }

    else if (isACaseOf(actions.delete.success)) {
      return answer(Status.OK,
        state.items.delete(action.id),
        state.inProgress.delete(state.inProgress.indexOf(action.id)));
    }

    else if (isACaseOf(actions.put.success)) {
      return answer(Status.OK,
        state.items.set(action.payload.id, action.payload),
        state.inProgress.delete(state.inProgress.indexOf(action.id)));
    }

    else if (isACaseOf(actions.post.success)) {
      return answer(Status.OK,
        state.items.set(action.payload.id, action.payload),
        state.inProgress.delete(state.inProgress.indexOf(-1)));
    }
    else if (isACaseOf(actions.post.failure)) {
      return answer(Status.FAILURE,
        state.items,
        state.inProgress.delete(state.inProgress.indexOf(-1)));
    }
    else if (isACaseOf(actions.post.start)) {
      return answer(undefined, undefined,
        state.inProgress.push(-1));
    }

    else if (isACaseOf(actions.put.failure, actions.delete.failure)) {
      const id = action.payload ? action.payload.id : action.id;
      return answer(undefined, undefined,
        state.inProgress.delete(state.inProgress.indexOf(id)));

    }

    else if (isACaseOf(actions.put.start, actions.delete.start)) {
      const id = action.payload ? action.payload.id : action.id;
      return answer(undefined, undefined,
        state.inProgress.push(id));
    }

    else if (isACaseOf(actions.reset)) {
      return initialState;
    }

    else {
      return fallback ? fallback(state, action) : state;
    }
  };
}


/** Aplatit les élements d'un tableau contenant des tableaux */
function flatten(arr) {
  return arr.reduce(function (flat, toFlatten) {
    return flat.concat(Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten);
  }, []);
}


/** Etat initial d'une collection REST */
const initialState = {
  status: Status.LOADING,
  items: Map(),
  inProgress: List()
};


/** Met à jour un état à partir de nouvelles valeurs */
const stateGenerator = (previous) => {
  return (status = previous.status, items = previous.items, inProgress = previous.inProgress) => {
    return {
      status: status,
      items: items,
      inProgress: inProgress
    };
  }
};



// WEBPACK FOOTER //
// ./src/redux/_utils/restReducer.js